/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import instance from "services/axiosServices";
import backofficeEnviroment from "utils/backofficeEnviroment";

interface Props {
  idUnidade: string | null;
  idsSerie: string[];
  idLeadCorretor: any;
  idOportunidade?: any;
}

export function useExcluirSeries(props: Props) {
  const postData = async () => {
    const EXCLUIR_SERIES = `${backofficeEnviroment}/common/oportunidades-lead/excluir-series/v1`;
    const { data } = await instance.put(EXCLUIR_SERIES, {
      idUnidade: props.idUnidade,
      idsSerie: props.idsSerie,
      idLeadCorretor: props.idLeadCorretor,
      idOportunidade: props.idOportunidade,
    });
    return data;
  };

  const mutation = useMutation(postData, {
    onSuccess: () => {
      toast.success("Series excluídas com sucesso!");
    },
    onError: (error: any) => {
      toast.error(
        `Erro ao excluir series. Motivos: ${error.response.data.notifications.map(
          (item: any) => item?.message
        )} `,
        { autoClose: 10000 }
      );
    },
  });

  return mutation;
}
